export const PRODUCT_LIST_TEST_ID = {
  item: 'checkout-item',
  name: 'product-name',
  cost: 'product-total-cost',
};
